import { SerializedStyles, css } from '@emotion/react';

export const styleNavIcon = (): SerializedStyles => css`
    fill: currentcolor;
    flex: 0 0 24px;
    width: 24px;
`;

export const logoBaseCss = (): SerializedStyles => css`
    display: block;
    margin: 0 auto 16px;
`;
